import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";
import "firebase/analytics";

var firebaseConfig = {
  apiKey: "AIzaSyCto9_XTsNxeWHPME79uJIYPWr7kQTXH4g",
  authDomain: "paradigma-firebase.firebaseapp.com",
  databaseURL: "https://paradigma-firebase.firebaseio.com/",
  projectId: "paradigma-firebase",
  storageBucket: "paradigma-firebase.appspot.com",
  messagingSenderId: "952471021945",
  appId: "1:952471021945:web:08b14743e71d1dfc",
  measurementId: "G-CJKWPN8V9J",
};

firebase.initializeApp(firebaseConfig);

firebase.firestore().settings({ ignoreUndefinedProperties: true, merge: true });

const analytics = firebase.analytics();
const firestore = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_FIREBASE_EMULATOR === "true"
) {
  auth.useEmulator("http://localhost:9099");
  firestore.useEmulator("localhost", 8080);
}

export { analytics, firestore, auth, storage };

export default firebase;
